<template>
  <div>
    <div class="content" v-if="isPC">
      <div class="banner-head">
        <oss-img src="https://img.kakaclo.com/web-img/index/best_seller1.jpg" :width="1380" :height="181" />
      </div>
      <el-tabs ref="sellTab" v-model="activeName" @tab-click="handleTab" class="sellTab">
        <el-tab-pane :label="$t('commodity.Components.Sale.AutumnWinter')" name="Autumn-Winter" />
        <el-tab-pane :label="$t('commodity.Components.Sale.SpringSummer')" name="Spring-Summer" />
        <el-tab-pane :label="$t('commodity.Components.Sale.FourSeasons')" name="Four Seasons" />
        <el-tab-pane :label="$t('commodity.Components.Sale.Festival')" name="Festival" />
      </el-tabs>
      <CommodityList :sortName="sortName" :attribute="attribute" />
    </div>
    <div v-else class="mobile-sale bg-white">
      <el-tabs ref="sellTab" v-model="activeName" @tab-click="handleTab" class="sellTab">
        <el-tab-pane :label="$t('commodity.Components.Sale.AutumnWinter')" name="Autumn-Winter" />
        <el-tab-pane :label="$t('commodity.Components.Sale.SpringSummer')" name="Spring-Summer" />
        <el-tab-pane :label="$t('commodity.Components.Sale.FourSeasons')" name="Four Seasons" />
        <el-tab-pane :label="$t('commodity.Components.Sale.Festival')" name="Festival" />
      </el-tabs>
      <oss-img src="https://img.kakaclo.com/web-img/index/best_seller1.jpg" :width="172" style="width:100%" :height="23"></oss-img>
      <CommodityList :sortName="sortName" :attribute="attribute" />

      <!-- 返回顶部 -->
      <el-backtop :bottom="190" :right="6" class="backtop">
        <img style="width:70px;height:70px" src="@/assets/img/homePage/backtop.png" alt="" />
      </el-backtop>
    </div>
  </div>
</template>

<script>
import CommodityList from '@/views/commodity/components/CommodityList.vue'
import OssImg from '../../../components/OssImg.vue'
export default {
  components: {
    CommodityList,
    OssImg
  },
  data() {
    return {
      sortName: '3',
      activeName: 'Autumn-Winter',
      attribute: JSON.stringify([{ code: 'season', value: ['Autumn-Winter'] }])
    }
  },
  created() {
  },
  methods: {
    handleTab() {
      this.attribute = JSON.stringify([{
        code: 'season', value: [this.activeName]
      }])
    }
  }
}
</script>

<style lang="scss" scoped>
.sellTab {
  background-color: #fff;
  padding: 8px 30px 1px 30px;
  /deep/ .el-tabs__header{
    margin: 0;

    .el-tabs__nav-wrap::after{
      width: 0;
      height: 0;
    }
    .el-tabs__item {
      height: 46px;
      color: #999;
    }
    .el-tabs__item.is-active{
      color: #000;
    }
    .el-tabs__active-bar{
      background-color: #000;
    }
  }
}

.content {
  max-width: 1400px;
  min-width: 1000px;
  margin: 0 auto;
  padding: 0 15px;
}
.banner-head {
  max-width: 1380px;
  border-radius: 12px;
  padding: 30px 0 5px 0;
  img {
    width: 100%;
    border-radius: 12px;
    object-fit: contain;
  }
}
.mobile-sale{
  padding: 0.2rem 0.3rem;
  min-height: calc(100vh - 0.9rem);
  .sellTab{
    padding: 0px 0 1px 0;
    margin-bottom: 10px;
  }
}
</style>
